import { US_STATES } from '@/constants';

export {
  US_STATES
};

export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'non-binary', label: 'Non-Binary' },
  { value: 'other', label: 'Other' },
  { value: 'prefer-not-say', label: 'Prefer not to say' }
];

export const GRADE_LEVELS = Array.from({ length: 13 }, (_, i) => ({
  value: String(i),
  label: i === 0 ? 'Kindergarten' : `Grade ${i}`
}));

export const GUARDIAN_RELATIONSHIPS = [
  { value: 'parent', label: 'Parent' },
  { value: 'legal-guardian', label: 'Legal Guardian' },
  { value: 'grandparent', label: 'Grandparent' },
  { value: 'foster-parent', label: 'Foster Parent' },
  { value: 'aunt-uncle', label: 'Aunt/Uncle' },
  { value: 'sibling', label: 'Sibling' },
  { value: 'other', label: 'Other' }
];

export const ATTENDANCE_STATUS = [
  { value: 'active', label: 'Active' },
  { value: 'chronic-absence', label: 'Chronic Absence' },
  { value: 'withdrawn', label: 'Withdrawn' }
];

export const PERFORMANCE_LEVELS = [
  { value: 'below-average', label: 'Below Average' },
  { value: 'average', label: 'Average' },
  { value: 'above-average', label: 'Above Average' },
  { value: 'excellent', label: 'Excellent' }
];

export const YES_NO = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' }
];

export const IMMUNIZATION_STATUS = [
  { value: 'complete', label: 'Complete' },
  { value: 'incomplete', label: 'Incomplete' },
  { value: 'exempt', label: 'Exempt' }
];

export const SUPPORT_PLAN_STATUS = [
  { value: 'not-started', label: 'Not Started' },
  { value: 'in-progress', label: 'In Progress' },
  { value: 'completed', label: 'Completed' }
];

export const TRANSPORTATION_METHODS = [
  { value: 'bus', label: 'Bus' },
  { value: 'car', label: 'Car' },
  { value: 'walk', label: 'Walk' },
  { value: 'other', label: 'Other' }
];